<span *ngIf="!isProd" [class]="'ribbon ribbon-' + environmentName">{{appVersion}}</span>
<div class="primary-router-outlet-container">
  <router-outlet></router-outlet>
</div>

<app-loader></app-loader>
